export default __webpack_public_path__ + "static/media/img-id-frame@3x.f39f42e7.png";